module.exports = __webpack_public_path__ + "media/images/bsmart/icons/side_menu_correggere_attivo-a38492decc77c4bed0960f2522c76a95.svg";